<template>
  <div
    class="ticker ticker1 ticker--1 lp-section width-expand relative z-level-top1"
    :id="`Ticker1-${pageUid}`">
    <div
      class="ticker-element flex-column flex-stretch"
      :class="`bg-${backgroundColor} c-${triggerTextColor}`">
      <div
        class="ticker-trigger flex-middle gap-m flex-center cursor-pointer"
        @click="
          track('ticker1|trigger|click', { value: triggerText }).then(toggle)
        ">
        <h3
          class="margin-remove text-center bold text-m"
          :class="`c-${triggerTextColor}`">
          {{ triggerText }}
        </h3>
        <icon
          class="trigger-icon animate__fadeIn animate--fastest"
          icon="chevron-up"
          v-show="!isOpened"
          :theme="iconColor"
          size="1.5"></icon>
        <icon
          class="trigger-icon animate__fadeIn animate--fastest"
          icon="chevron-down"
          v-show="isOpened"
          :theme="iconColor"
          size="1.5"></icon>
      </div>
      <div
        class="trigger-content margin-m-top text-center padding-l-inline padding-l-bottom"
        v-show="isOpened">
        <h3
          class="margin-s-bottom text-xl width-expand text-center animate__fadeIn animate--fastest"
          v-show="isOpened"
          v-if="isNonEmptyString(innerText)"
          :class="`c-${innerTextColor}`">
          {{ innerText }}
        </h3>
        <div
          class="button-container flex-center animate__fadeIn animate--fastest"
          v-if="button.show">
          <form-button
            v-bind="button"
            v-show="isOpened"
            @click="
              track('ticker1|button|click', { value: button.text }).then(
                button.navigationHandler
              )
            "></form-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");

    let schema = {
      triggerText: "",
      innerText: "",
      button: {},
      topOffset: "",
      backgroundColor: "",
      triggerTextColor: "",
      innerTextColor: "",
      iconColor: "",
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    return {
      isOpened: false,
    };
  },
  computed: {
    mobileTopProperty() {
      return `${this.topOffset}px`;
    },
  },
  methods: {
    open() {
      this.isOpened = true;
    },
    close() {
      this.isOpened = false;
    },
    toggle() {
      this.isOpened = !this.isOpened;
    },
  },
};
</script>

<style scoped lang="scss">
.ticker1 {
  .ticker-element {
    position: fixed;
    z-index: var(--z-top-2);
    padding: var(--margin-s) var(--margin-l) var(--margin-s) var(--margin-l);

    bottom: 0px;
    // the width and fixed value in offset depend on each other
    min-width: 250px;
    max-width: calc(100% - 2 * var(--container-gutter));
    inset-inline-start: calc(50% - (1 / 2 * var(--container)) + 38px);
    transform: translateX(50%);
    border-radius: var(--border-radius-l) var(--border-radius-l) 0 0;

    @media (max-width: 1024px) {
      // if we ever want this to be absolute,
      // abandon the "offset" field idea
      // and the admin has to put it right after the header.
      bottom: auto;
      border-radius: 0 0 var(--border-radius-l) var(--border-radius-l);
      top: v-bind(mobileTopProperty);
      min-width: 250px;
      inset-inline-start: 50%;
      transform: translateX(50%);
    }

    .trigger-icon {
      @media (max-width: 1024px) {
        transform: rotate(180deg);
      }
    }

    .ticker-trigger {
      border-radius: var(--border-radius-l) var(--border-radius-l) 0 0;

      @media (max-width: 1024px) {
        border-radius: 0 0 var(--border-radius-l) var(--border-radius-l);
        order: 2;
      }
    }

    .ticker-content {
      @media (max-width: 1024px) {
        order: 1;
      }
    }
  }
}
</style>
